import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Cookies from "js-cookie";

function UpcomingEvents() {
	const navigate = useNavigate();
	const [events, setEvents] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const fetchEvents = async () => {
			try {
				const token = Cookies.get("userToken");
				const response = await axios.get(
					`${process.env.REACT_APP_BACKEND_URL}/apis/user/getAllUpComingEvent`,
					{ headers: { Authorization: `Bearer ${token}` } }
				);
				setEvents(response.data.message || []);
			} catch (error) {
				console.error("Error fetching events:", error);
			} finally {
				setLoading(false);
			}
		};
		fetchEvents();
	}, []);

	const handleEventClick = () => navigate("/event");

	// Skeleton Loader Component
	const EventSkeleton = () => (
		<div className="bg-white rounded-xl shadow-sm overflow-hidden border border-stone-200 animate-pulse">
			<div className="flex p-4">
				<div className="w-20 h-20 rounded-lg bg-stone-200"></div>
				<div className="ml-4 flex-1 space-y-2">
					<div className="h-4 w-3/4 bg-stone-200 rounded"></div>
					<div className="h-3 w-1/2 bg-stone-200 rounded"></div>
					<div className="h-3 w-full bg-stone-200 rounded"></div>
					<div className="h-3 w-4/5 bg-stone-200 rounded"></div>
					<div className="h-4 w-24 bg-stone-200 rounded mt-3"></div>
				</div>
			</div>
		</div>
	);

	return (
		<div className="space-y-6">
			<h2 className="text-xl font-bold text-stone-700 px-2">Upcoming Events</h2>

			{loading ? (
				<>
					<EventSkeleton />
					<EventSkeleton />
				</>
			) : events.length > 0 ? (
				events.slice(0, 2).map((event) => (
					<div
						key={event._id}
						className="bg-white rounded-xl shadow-sm overflow-hidden border border-stone-200 hover:shadow-md transition-shadow"
					>
						<div className="flex p-4">
							<img
								src={event.image || "assets/event1.png"}
								alt="Event"
								className="w-20 h-20 rounded-lg object-cover border border-stone-200"
								onError={(e) => {
									e.target.onerror = null;
									e.target.src = "assets/default-event.png";
								}}
							/>
							<div className="ml-4 flex-1">
								<h3 className="font-semibold text-stone-800">
									{event.adminProfile?.collegeName || "College Event"}
								</h3>
								<p className="text-sm text-stone-600 mt-1 line-clamp-2">
									{event.title || "Annual College Festival"}
								</p>
								<p className="text-xs text-stone-500 mt-1 line-clamp-2">
									{event.description || "Join us for music, dance and cultural performances. Open to all students."}
								</p>
								<button
									onClick={handleEventClick}
									className="mt-3 text-amber-600 text-sm font-medium flex items-center hover:text-amber-700 transition-colors"
								>
									View Details
									<svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
									</svg>
								</button>
							</div>
						</div>
					</div>
				))
			) : (
				<div className="bg-white rounded-xl p-6 text-center border border-stone-200">
					<p className="text-stone-500">No upcoming events scheduled</p>
				</div>
			)}
		</div>
	);
}

export default UpcomingEvents;